module.exports = __webpack_public_path__ + "static/media/secretBanner_sm1.21017e5d.png";